export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    treeNode: true,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_showGoods') || '产品',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    slots: { default: 'showGoods' },
  },
  {
    title: that.$l('table_label_orderQty') || '订单数量',
    field: 'orderQty',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    slots: { default: 'orderQty' },
  //   formatter: ({ row }) => {
  //     return that.format(row.orderQty)
  //   },
  },
  {
    title: that.$l('table_label_quote') || '含税成本',
    field: 'quote',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.quote)
    },
  },
  {
    title: that.$l('table_label_fabricCost') || '面料成本',
    field: 'fabricCost',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.fabricCost)
    },
  },
  {
    title: that.$l('table_label_materialCost') || '辅料成本',
    field: 'materialCost',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.materialCost)
    },
  },
  {
    title: that.$l('table_label_laborCost') || '人工成本',
    field: 'laborCost',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.laborCost)
    },
  },
  {
    title: that.$l('table_label_packingCost') || '包装成本',
    field: 'packingCost',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.packingCost)
    },
  },
  {
    title: that.$l('table_label_otherCost') || '其他费用',
    field: 'otherCost',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.otherCost)
    },
  },
  {
    title: that.$l('table_label_totalCostAmount') || '不含税成本',
    field: 'totalCostAmount',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.totalCostAmount)
    },
  },
  {
    title: that.$l('table_label_managementFee') || '管理费',
    field: 'managementFee',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.managementFee)
    },
  },
  {
    title: that.$l('table_label_profit') || '毛利',
    field: 'profit',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.profit)
    },
  },
  {
    title: that.$l('table_label_vat') || '增值税',
    field: 'vat',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      return that.format(row.vat)
    },
  },
]
